export default __webpack_public_path__ + "static/media/wellness_accounts.90bd4971.svg";